<template>
  <div class="placeholder-list">
    <p>
      You have following placeholder to fill in. 
      You can copy them and ask AI to update document with provided values or provide values in place.   
    </p>
    <!-- <ul class="placeholder-list">
      <li v-for="p in attachment.object">{{ p }}</li>      
    </ul> -->
    <table class="placeholder-list-table">
      <tbody>
        <Tippy :content="p" v-for="p in attachment.object" is="tr" :hideOnClick="false">
          <td>✨</td>
          <td :style="{
            'white-space': 'nowrap',
            'max-width': '200px'
          }">{{ p }}</td>
          <td><input type="text" :value="values[p] || ''" @change="e => values[p] = e.target.value " /></td>
        </Tippy>

      </tbody>
      
    </table>


    <Button @action="sendToChat" class="btn-sm btn-primary self-end">Update document</Button>

  </div>
</template>

<script setup>
import { ref } from 'vue';
import Button from '../../components/Button.vue';
import { Events } from '../../events';
import Tippy from '../../components/Tippy.vue';

  defineProps(['attachment'])

  const values = ref({})


  function sendToChat() {

    const vals = values.value

    const entries = Object.entries(vals).filter(([k, v]) => !!v).map(([k, v]) => {
      return `${k}: ${v}`
    }).join('\n')

    const prompt = `Update the document’s placeholders with the following:\n${entries}`

    Events.dispatch(Events.CHAT_QUESTION, { 
      prompt
    })

  }
</script>

<style lang="less">
  .placeholder-list {
    padding-bottom: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  // .placeholder-list {
  //   list-style: none;
  //   padding-left: 10px;
  //   li::before {
  //     content: "✨";
  //     margin-right: 0.5rem;
  //   }
  // }
  .placeholder-list-table {
    border-radius: 8px;
    tr:hover {
      background: #292929;

    }

    td {
      padding: 2px 5px;
    }
    td:first-child {
      border-radius: 10px 0 0 10px
    }
    td:last-child {
      border-radius: 0 10px 10px 0;
      padding-right: 5px;
      width: 100%;
    }
    input {
      padding: 1px 10px;
      background: var(--color-base-100);
      border-radius: 8px;
      font-size: 16px;
      width: 100%;
    }
    input:focus-visible {
      outline: 1px solid var(--color-primary);
      outline-offset: -1px;
    }
  }
</style>